import { render } from "./GuestReview.vue?vue&type=template&id=d9c3613e"
import script from "./GuestReview.vue?vue&type=script&lang=js"
export * from "./GuestReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__